import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import { ApiProvider } from "../providers/apiProvider";

const WorkerMatchVerification = ({ show, verifyLastName, verifyPhoneNumber, verified, cancel }) => {
    const {t} = useTranslation();
    
    const {instance, accounts} = useMsal();
    const _api = new ApiProvider(instance, accounts[0]);
    const [formattedPhone, setFormattedPhone] = useState();
    const [messageSent, setMessageSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState();
    const [verificationAssociateId, setVerificationAssociateId] = useState();
    
    useEffect(() => {
        setFormattedPhone(verifyPhoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'))
    }, [verifyLastName, verifyPhoneNumber])

    const startAuthentication = async () => {
        
        const response = await _api.Post(`associate/startauthentication`, 
               {
                    lastName: verifyLastName,
                    phoneNumber: verifyPhoneNumber,
                    language: window.language
                });
        if (response.error != null){
            console.error(response.error);
            return;
        }
        setVerificationAssociateId(response);
        setMessageSent(true);
    }

    const verificationCodeChange = (value) => {
        setVerificationCode(value);
    }

    const reset = () => {
        setMessageSent(false);
        setVerificationCode(null);
    }

    const resetCancel = () => {
        reset();
        cancel();
    }

    const validateCode = async () => {
        
        const params = {
            associateId: verificationAssociateId,
            lastName: verifyLastName,
            phoneNumber: verifyPhoneNumber,
            code: verificationCode,
            language: window.language
        };
        
        const response = await _api.Post('associate/continueauthentication', params);
        if (response.error != null){
            console.error(response.error);
            return;
        }
        verified(verificationCode, response)
    }

    return (
        <>
        
        <Modal show={show} size={'lg'} centered backdrop={true}>
            <Modal.Header>
                {t("Verify Worker")}
            </Modal.Header>
            <Modal.Body>

                <Row>
                    <Col>
                        {t('Verify Worker Instruction')}
                        <Button onClick={e => startAuthentication()} variant="link">{t('Request Verification Code')}</Button>
                        {/* {'If you are unable to verify your phone number please request a code from an instructor at orientation.'} */}
                    </Col>
                </Row>
                <Row>
                    <Col className="py-3">
                        {messageSent && (
                            <div>
                            {t('Verify Code Sent') + formattedPhone + '. ' + t('Please Enter Verification Code')}
                            <p/>
                            {t('Enter Code') + ':'} <input className="fs-6 form-control" onChange={(e) => verificationCodeChange(e.target.value)} type="text" />
                            </div>
                        )}
                    </Col>
                </Row>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant='primary' onClick={resetCancel}>{t('Cancel')}</Button>
                {messageSent && (<Button variant='primary' onClick={validateCode}>{t('Verify')}</Button>)}
            </Modal.Footer>
        </Modal>
        
        </>
                    
    );
}
 
export default WorkerMatchVerification